import { colors } from '../../constants';
const MuiInput = {
  root: {
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderRadius: 24,
    'label + &': {
      marginTop: 15
    },
    backgroundColor: colors.oriGrey[100],
    '&:hover': {
      backgroundColor: colors.oriGrey[100]
    },
    '&$focused': {
      backgroundColor: colors.oriGrey[100]
    }
  },
  input: {
    padding: '14px 17px'
  },
  inputMarginDense: {
    paddingTop: 6,
    paddingBottom: 6
  },
  multiline: {
    '&$marginDense': {
      paddingTop: 6,
      paddingBottom: 6
    },
    padding: '14px 15px'
  }
};
export default MuiInput;